/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const generateTitleAudioIdsResultSchema = z.object({
  ids: z.array(z.number()),
  remaining: z.number(),
});

export type IGenerateTitleAudioIdsResult = z.infer<typeof generateTitleAudioIdsResultSchema>;

export const generateTitleAudioIdsResponseSchema = createApiResponseSchema(
  generateTitleAudioIdsResultSchema,
) as z.ZodSchema<IAPI<IGenerateTitleAudioIdsResult>>;

export type IGenerateTitleAudioIdsResponse = IAPI<IGenerateTitleAudioIdsResult>;
